const author = {
  esp: 'Tatjana Auderskaja',
  ru: 'Татьяна Аудерская'
};

export default author;